export default __webpack_public_path__ + "static/media/WW).25d9b34d.svg";